export const SEMESTER_WEEKS = 16 as const;
export const YEARLY_WEEKS = 52 as const;

export const PAYG_PRICE_PER_GEN_MAD = 1.2;
export const PAYG_MIN_GENERATIONS = 20 as const;
export const PAYG_MAX_GENERATIONS = 78 as const;

export const FREE_TRIAL_PRICE_MAD = 0 as const;
export const STARTER_SEMESTER_MAD = 39 as const;
export const STARTER_YEARLY_MAD = 79 as const;
export const PRO_SEMESTER_MAD = 79 as const;
export const PRO_YEARLY_MAD = 149 as const;

export type SubscriptionPlan = "starter" | "pro";
export type BillingCycle = "semester" | "yearly";

export function subscriptionPriceMad(
  plan: SubscriptionPlan,
  cycle: BillingCycle,
): number {
  if (plan === "starter") {
    return cycle === "semester" ? STARTER_SEMESTER_MAD : STARTER_YEARLY_MAD;
  }
  return cycle === "semester" ? PRO_SEMESTER_MAD : PRO_YEARLY_MAD;
}

export function paygTotalMad(credits: number): number {
  return Math.round(credits * PAYG_PRICE_PER_GEN_MAD * 10) / 10;
}

/** Savings against purchasing two semesters. Never returns a negative claim. */
export function yearlySavingsMad(plan: SubscriptionPlan): number {
  return Math.max(
    0,
    subscriptionPriceMad(plan, "semester") * 2 -
      subscriptionPriceMad(plan, "yearly"),
  );
}
